"use strict";

var PlanCardProLoading = React.createClass({
  render: function() {
    return (
      <div className="planCard p-r">
        <div className="planCard-headBackground pt-25"></div>
        <div className="planCardProLoading-usersCapacity"></div>
        <div className="mt-30 w-160 m-a p-r">
          <div className="f-l planCardLoading-leftInputArrows">-</div>
          <input type="text"  className="planCardLoading-picker" readOnly/>
          <div className="f-r planCardLoading-rightInputArrows">+</div>
        </div>
        <ul className="mt-100">
          <li className="mt-10">
            <div className="planCardLoading-features"/>
          </li>
          <li className="mt-15">
            <div className="planCardLoading-features"/>
          </li>
          <li className="mt-15">
            <div className="planCardLoading-features"/>
          </li>
          <li className="mt-15">
            <div className="planCardLoading-features"/>
          </li>
          <li className="mt-15">
            <div className="planCardLoading-features"/>
          </li>
          <li className="mt-15">
            <div className="planCardLoading-features"/>
          </li>
          <li className="mt-15">
            <div className="planCardLoading-features"/>
          </li>
        </ul>
        <div className="mb-137"></div>
        <div className="planCardLoading-opacity"></div>
      </div>
    );
  },
});

module.exports = PlanCardProLoading;



// WEBPACK FOOTER //
// ./app/screens/Pricing/components/PlanSelector/plan-card-pro-loading.jsx